import styled from '@emotion/styled/macro';
import { ReactComponent as IconUmbrella } from '../../svgs/cra-umbrella.svg';
import { AnimatePresence, motion } from 'framer-motion';
import { useSelector } from 'react-redux';
import { postPreventMetrics } from '../../store/api';

const Icon = styled.div`
  color: var(--color-actuators);
  margin-right: 0.6rem;
`;

const TextAndIconWrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  width: 100%;
`;

const ItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ChoicesWrapper = styled(motion.div)`
  padding-top: 0.4rem;
  overflow: hidden;
  width: 100%;
`;

const ChoicesAnimatedWrapper = styled(motion.div)`
  display: flex;
  width: 100%;
  /* indent under the label, past the icon (1rem icon + 0.6rem margin) */
  padding-left: 1.6rem;
`;

const SubText = styled.span`
  font-size: var(--font-size-14);
  color: var(--color-gray);
  line-height: 1.4;
`;

const PreventionLabelAndDescription = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  word-break: break-word;
`;
const PreventionItem = (props) => {
  const { prevention, isExpanded, onToggle } = props;
  const sessionId = useSelector((state) => state.api.sessionId);

  const handleExpandClick = () => {
    onToggle();
    postPreventMetrics(sessionId, 'PREVENT_EXPANDED');
  };

  return (
    <ItemWrapper>
      <TextAndIconWrapper onClick={() => handleExpandClick()}>
        <Icon>
          <IconUmbrella
            stroke="currentColor"
            fill="currentColor"
            strokeWidth="0"
            width="1rem"
            height="1rem"
          />
        </Icon>
        <PreventionLabelAndDescription>
          <span>{prevention.actuatorTag}</span>
          <SubText>{prevention.description}</SubText>
        </PreventionLabelAndDescription>
      </TextAndIconWrapper>
      {/*enable after backend*/}
      <AnimatePresence>
        {isExpanded && (
          <ChoicesWrapper
            key="content"
            initial="collapsed"
            animate="open"
            exit="collapsed"
            variants={{
              open: { opacity: 1, height: 'auto' },
              collapsed: { opacity: 0, height: 0 },
            }}
            transition={{ type: 'tween' }}
          >
            <ChoicesAnimatedWrapper>
              <SubText>{prevention.action}</SubText>
            </ChoicesAnimatedWrapper>
          </ChoicesWrapper>
        )}
      </AnimatePresence>
    </ItemWrapper>
  );
};

export default PreventionItem;
